import {Delete, FormPost, GET, POST} from "../util";

const operationUrl = "api/receivable-operation/";
const inspectionUrl = "api/receivable-inspection/";
const commenReceivableUrl = "api/common/receivable/";

const url = {
    operation: {
        uploadPdf: `${operationUrl}upload-with-pdf`,
        uploadXml: `${operationUrl}upload-with-xml-or-excel`,
        uploadDocuments: `${operationUrl}bulk-upload-invoice-documents`,
        uploadSingle: `${operationUrl}single-upload-invoice-doc`,
        submitReview: `${operationUrl}submit-for-review`,
        deleteOperation: `${operationUrl}delete`,
        resetOperation: `${operationUrl}reset`,
        bundle: `${operationUrl}bundle-receivables`,
        smartBundle: `${operationUrl}smart-bundle-receivables`,
        unbundle: `${operationUrl}unbundle-receivable`,
        saveItem: `${operationUrl}save`,
        saveAndSubmit: `${operationUrl}save-and-submit-for-review`,
        uploadInvoice: `${operationUrl}single-upload-invoice-doc`,
        uploadProofOfDelivery: `${operationUrl}upload-proof-of-delivery-document`
    },
    inspection: {
        new: `${inspectionUrl}list-new`,
        waiting: `${inspectionUrl}list-waiting`,
        declined: `${inspectionUrl}list-declined`,
        counts: `${inspectionUrl}counts`,
        receivableDetail: `${commenReceivableUrl}details`,
        receivableDetailWithAiAutoFills: `${inspectionUrl}details-with-ai-auto-fill`,
        availableDebtors: `${inspectionUrl}debtor/available`,
        documentList: `${inspectionUrl}documents/info/`,
        singleConfirmationData: `${inspectionUrl}confirmation-data/single`,
        multiConfirmationData: `${inspectionUrl}confirmation-data/multi`,
        suggestPricing: `${inspectionUrl}suggest-pricing`,
        inheritedPartnerPrefs: `${inspectionUrl}partnerprefs`
    }
};

const receivableApi = {
    inspection: {
        counts: () => {
            return GET(url.inspection.counts);
        },
        listNew: (params = {}) => {
            return POST(url.inspection.new, params);
        },
        listWaiting: (params = {}) => {
            return POST(url.inspection.waiting, params);
        },
        listDeclined: (params = {}) => {
            return POST(url.inspection.declined, params);
        },
        loadSingleConfirmationData: (params = {}) => {
            return POST(url.inspection.singleConfirmationData, params);
        },
        loadMultiConfirmationData: (params = {}) => {
            return POST(url.inspection.multiConfirmationData, params, "application/json", 'Array');
        },
        suggestPricing(params) {
            return POST(url.inspection.suggestPricing, params);
        },
        getInheritedPartnerPrefs: (params = {}) => {
            return GET(url.inspection.inheritedPartnerPrefs, params);
        }
    },
    uploadDocuments: (params = {}) => {
        return FormPost(url.operation.uploadDocuments, params);
    },
    uploadProofOfDelivery: (params = {}) => {
        return FormPost(url.operation.uploadProofOfDelivery, params);
    },
    uploadPdf: (params = {}) => {
        return FormPost(url.operation.uploadPdf, params);
    },
    uploadXml: (params = {}) => {
        return FormPost(url.operation.uploadXml, params);
    },
    submitReview: (params = {}) => {
        return POST(url.operation.submitReview, params, "application/json", 'Array');
    },
    deleteOperation: (params = {}) => {
        return Delete(url.operation.deleteOperation, params, "application/json", 'Array');
    },
    receivableDetail: (id) => {
        return GET(url.inspection.receivableDetail + '/' + id, {}, false);
    },
    receivableDetailWithAiAutoFills: (id) => {
        return GET(url.inspection.receivableDetailWithAiAutoFills + '/' + id, {}, false);
    },
    resetOperation: (params = {}) => {
        return POST(url.operation.resetOperation, params, "application/json", 'Array');
    },
    bundle: (params = {}, useRetention = false) => {
        return POST(url.operation.bundle + "?useRetentionIfApplicable=" + useRetention, params, "application/json", 'Array');
    },
    smartBundle: (useRetention = false) => {
        return POST(url.operation.smartBundle + "?useRetentionIfApplicable=" + useRetention);
    },
    unbundle: (id) => {
        return POST(url.operation.unbundle + '/' + id);
    },
    availableDebtors: () => {
        return GET(url.inspection.availableDebtors);
    },
    saveItem: (params = {}) => {
        return POST(url.operation.saveItem, params);
    },
    saveAndSubmit: (params = {}) => {
        return POST(url.operation.saveAndSubmit, params);
    },
    uploadInvoice: (id, params) => {
        return FormPost(url.operation.uploadInvoice + '/' + id, params);
    },
    allReceivableDocuments: (token, purpose) => {
        return GET(url.inspection.documentList + "?token=" + token + " &purpose=" + purpose);
    },
};
export {
    receivableApi
};